import * as React from 'react'
import { Svg } from '../icon'

type LogoProps = any & {
	variantColor?: 'dark' | 'light'
}

const LogoMark: React.FC<LogoProps> = (props: LogoProps): React.ReactElement => {
	const {
		variantColor,
		...rest
	} = props

	let fillColor = '#010101'
	if (variantColor === 'light') {
		fillColor = '#ffffff'
	}

	const opts = {...props}
	opts.height = opts.height || 100

	return (
		<Svg viewBox="0 0 88.7 90" xmlSpace="preserve" {...opts}>
			<g fill={fillColor}>
				<g>
					<g>
						<g>
							<path d="M81.6,22c-0.4,0.2-1,0.3-1.4,0.3H9.4c-0.4,0-0.8-0.3-1-0.7L0,0.7C-0.1,0.3,0.1,0,0.5,0l12.1,0c0.4,0,1,0.2,1.4,0.4
								l21.5,17.8c0.3,0.2,1,0.4,1.4,0.4h43.5c0.4,0,1,0.1,1.4,0.3l2.4,1.2c0.4,0.2,0.4,0.5,0,0.7L81.6,22z"/>
							<g>
								<path d="M53,17l-0.4-0.9c-0.1-0.2-0.4-0.4-0.6-0.4H41c-0.2,0-0.5,0.2-0.6,0.4L40,17c0,0.1-0.1,0.3-0.1,0.4h13.2
									C53.1,17.3,53,17.1,53,17z"/>
							</g>
							<path d="M67,30.1c-5.3,0-9.6,3.8-10.5,8.8h-4.2l-0.5,3.8h4.7c0.9,5,5.2,8.8,10.5,8.8c5.9,0,10.7-4.8,10.7-10.7
								S72.9,30.1,67,30.1z M72.7,46c0.6-1.2,1-2.6,1-4.1c0-4.6-3.3-8.3-7.4-8.7c0.3,0,0.5-0.1,0.8-0.1c4.3,0,7.7,3.5,7.7,7.7
								C74.8,42.8,74,44.6,72.7,46z"/>
							<g>
								<path d="M41,42.7l-0.5-3.8h-4.3c-0.8-5-4.8-8.8-9.5-8.8c-5.4,0-9.7,4.8-9.7,10.7c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0.1,0,0.1
									c0.1,5.8,4.4,10.6,9.7,10.6h0c0,0,0,0,0,0c4.8,0,8.7-3.8,9.5-8.8H41z M25.8,48.5c-0.3,0-0.5-0.1-0.8-0.1
									c4.2-0.4,7.4-4.1,7.4-8.7c0-1.5-0.4-2.9-1-4.1c1.3,1.4,2.1,3.2,2.1,5.2C33.5,45,30,48.5,25.8,48.5z"/>
								<path d="M15.9,40.8c0-4.6,2.4-8.5,5.9-10.5c-4.2,1.6-7.2,5.7-7.2,10.5c0,4.8,3,8.9,7.2,10.5C18.3,49.3,15.9,45.3,15.9,40.8z"/>
							</g>
							<path d="M39.8,23.4l6,49.1c0,0.4,0.3,0.7,0.7,0.7c0.4,0,0.7-0.3,0.7-0.7l6-49.1H39.8z"/>
						</g>
					</g>
					<g>
						<g>
							<path fill="#06CCED" d="M57.1,63.4c9.7,1.8,14.8,6.2,11.5,10.3c-3.6,4.5-16,7-27.6,5.6c-10.7-1.3-17-5.5-15.2-9.6c0,0,0,0,0,0
								c-4.1,5.1,3.2,10.4,16.2,12c13,1.6,26.9-1.2,30.9-6.3C76.9,70.3,69.8,65,57.1,63.4z"/>
						</g>
						<g>
							<path fill="#0146E6" d="M54.8,82.5C40.5,83.9,26,80.5,22.3,75c-3.2-4.9,3-9.8,14.1-11.9c-13.7,2-21.7,7.7-18,13.3
								c3.9,6,19.6,9.6,35.1,8.1C68,83,77.2,77.6,75,71.9C75.5,76.8,67.3,81.3,54.8,82.5z"/>
						</g>
						<g>
							<path fill="#3ABA50" d="M85.1,71.8c0,8.3-17.3,15-38.7,15c-21.4,0-38.7-6.7-38.7-15c0-4.3,4.7-8.2,12.1-10.9
								c-9.4,3-15.5,7.6-15.5,12.7C4.3,82.7,23.2,90,46.5,90s42.2-7.3,42.2-16.4c0-5.3-6.6-10.1-16.8-13.1C80,63.3,85.1,67.3,85.1,71.8
								z"/>
						</g>
					</g>
				</g>
			</g>
		</Svg>
	)
}

export default LogoMark
